<span #cellContainer placement="top-left" [ngbTooltip]="displayValue" [disableTooltip]="shouldDisableTooltip">
  {{ displayValue }}
</span>
